/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/reflecting-on-a-heated-debate-at-apple",
  title: "Reflecting on a heated debate at Apple",
  description: `When I was 24 and working at Apple I found myself in a heated debate with an engineer that I'd not met before. 

Since I was young and knew everything, I was lecturing this man on some nuances of how drag and drop should behave when activated on a text selection.`,
  image: "/covers/threads/reflecting-on-a-heated-debate-at-apple.png",
  author: "Tom Conrad"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Tom Conrad",
      username: "tconrad",
      avatarUrl: "/avatars/tconrad.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/tconrad/status/1230308205315510272"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "When I was 24 and working at Apple I found myself in a heated debate with an engineer that I'd not met before."
      }), _jsx(_components.p, {
        children: "Since I was young and knew everything, I was lecturing this man on some nuances of how drag and drop should behave when activated on a text selection."
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `undefined`,
      children: _jsx(_components.p, {
        children: "In particular I had strong feelings about when a drag of selected text ended, what circumstances should initiate a copy of the selection, & what should initiate a move of the selection. I was going on and on while not letting this, much more experienced, engineer get a word in"
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "When the room cleared, my patient-beyond-words manager took me aside and suggested that I should consider being more inclusive about other people's experiences and insights."
      }), _jsx(_components.p, {
        children: "To make his point he shared that the engineer I'd been lecturing had in fact INVENTED COPY and PASTE."
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `undefined`,
      children: _jsx(_components.p, {
        children: "RIP Larry Tesler. I feel so lucky to have learned not just this lesson from you."
      })
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
